/*
   ****** The below React component is developed by AECS Private Limited. ******
   Please don't remove, replace, or edit this header information
   Component: <Alarms.js>
   Description: This React component handles the display of all pot data. It will show all the chambers data.
   Dependencies: This component uses Material-UI components, moment for date formatting, and custom components like Header, Footer, and Sidebar.
*/
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Map.css';
import { ContentContainer, MainContent, CenteredCard, StyledTableContainer, StyledTableContainerForDetailed, StyledTableHead, StyledTableColumn, StyledTableCell, RefreshIcon, HeaderTitle, CustomTextField } from '../Styles/Pot_Analytics';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLogoTitle } from '../classes/LogoTitleContext';
import Header from '../Parts/Header';
import Footer from '../Parts/Footer';
import { format } from 'date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Sidebar from '../Parts/Sidebar';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Grid from '@mui/material/Grid';
import CardContent from '@mui/material/CardContent';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { Radio, RadioGroup, FormControlLabel, Switch } from '@mui/material';
import pdfIcon from '../Images/pdf-icon.svg';
import excelIcon from '../Images/excel-icon.svg';
import axios from 'axios';
import getAuthHeaders from '../Auth/Authentication';
import { API_ENDPOINTS } from '../Auth/apiConfig';
import dayjs from 'dayjs';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import refreshIcon from '../Images/refresh-icon.svg';
import { utils, writeFile } from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const PotAnalytics = ({ onLogout, userData, loggedInUser }) => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState();
    const [username, setUsername] = useState();
    const [userRole, setUserRole] = useState('');
    const { logoUrl, projectTitle } = useLogoTitle();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [selectedDPs, setSelectedDPs] = useState([]);
    const [selectedVPs, setSelectedVPs] = useState([]);
    const [selectedLevels, setSelectedLevels] = useState([]);
    const parameterOptions = [
        { value: 'TotalDuration', label: 'Total run time' },
        { value: 'TotalDurationDay', label: 'Total run time/day' },
        { value: 'AverageDuration', label: 'Average run time' },
        { value: 'MaxDuration', label: 'Max run time' },
        { value: 'MinDuration', label: 'Min run time' },
        { value: 'TotalvalveCycles', label: 'Total valve runs' },
        { value: 'TotalvalveCyclesDay', label: 'Total runs/day' },
        { value: 'Totalvalvealarm', label: 'Total valve alarm' },
        { value: 'TotalFloatalarm', label: 'Total float alarm' }
    ];
    const [selectedParameters, setSelectedParameters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [potOptions, setPotOptions] = useState([]);
    const [potOptionsDefaultReport, setPotOptionsDefaultReport] = useState([]);
    const [selectedDateTo, setSelectedDateTo] = useState(null);
    const [detailedData, setDetailedData] = useState([]);
    const [detailedDataDefaultReport, setdetailedDataDefaultReport] = useState([]);
    const [detailedData2, setDetailedData2] = useState([]);
    const [detailedData2DefaultReport, setdetailedData2DefaultReport] = useState([]);
    const [detailedData3, setDetailedData3] = useState([]);
    const detailedData3Ref = useRef(null);
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 40);
    const [isVisible, setIsVisible] = useState(false);
    const notify = (message) => toast.info(message, {
        css: {
            fontSize: '16px',
            '@media (max-width: 600px)': {
                fontSize: '14px',
            },
        },
    });

    const [currentPageOne, setCurrentPageOne] = useState(1);
    const [currentPageTwo, setCurrentPageTwo] = useState(1);
    const [currentPageThree, setCurrentPageThree] = useState(1);
    const [currentPageFour, setCurrentPageFour] = useState(1);
    const [currentPageFive, setCurrentPageFive] = useState(1);

    const rowsPerPageOne = 15;
    const rowsPerPageTwo = 15;
    const rowsPerPageThree = 15;
    const rowsPerPageFour = 15;
    const rowsPerPageFive = 15;

    // Calculate the index range for the current page
    const startRowIndexOne = (currentPageOne - 1) * rowsPerPageOne;
    const endRowIndexOne = startRowIndexOne + rowsPerPageOne;

    // Calculate the index range for the current page
    const startRowIndexTwo = (currentPageTwo - 1) * rowsPerPageTwo;
    const endRowIndexTwo = startRowIndexTwo + rowsPerPageTwo;

    // Calculate the index range for the current page
    const startRowIndexThree = (currentPageThree - 1) * rowsPerPageThree;
    const endRowIndexThree = startRowIndexThree + rowsPerPageThree;

    // Calculate the index range for the current page
    const startRowIndexFour = (currentPageFour - 1) * rowsPerPageFour;
    const endRowIndexFour = startRowIndexFour + rowsPerPageFour;

    // Calculate the index range for the current page
    const startRowIndexFive = (currentPageFive - 1) * rowsPerPageFive;
    const endRowIndexFive = startRowIndexFive + rowsPerPageFive;

    // Paginate the data
    const paginatedDataOne = detailedDataDefaultReport.slice(startRowIndexOne, endRowIndexOne);
    const paginatedDataTwo = detailedData2DefaultReport.slice(startRowIndexTwo, endRowIndexTwo);
    const paginatedDataThree = detailedData.slice(startRowIndexThree, endRowIndexThree);
    const paginatedDataFour = detailedData2.slice(startRowIndexFour, endRowIndexFour);
    const paginatedDataFive = detailedData3.slice(startRowIndexFive, endRowIndexFive);

    // Handle page change event
    const handlePageChangeOne = (event, newPage) => {
        setCurrentPageOne(newPage);
    };

    // Handle page change event
    const handlePageChangeTwo = (event, newPage) => {
        setCurrentPageTwo(newPage);
    };

    // Handle page change event
    const handlePageChangeThree = (event, newPage) => {
        setCurrentPageThree(newPage);
    };

    // Handle page change event
    const handlePageChangeFour = (event, newPage) => {
        setCurrentPageFour(newPage);
    };

    // Handle page change event
    const handlePageChangeFive = (event, newPage) => {
        setCurrentPageFive(newPage);
    };

    const handleDefaultGenerate = async () => {
        setLoading(true);
        handleClear();

        // Get current date and date 7 days ago
        const currentDate = moment().format('YYYY-MM-DD');
        const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');

        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.potAnalyticsData}`, {
                selectedDPs,
                selectedVPs,
                selectedDateFrom: sevenDaysAgo,
                selectedDateTo: currentDate,
                projectID: loggedInUser.Projectid,
                TimeDiff: loggedInUser.TimeDiff,
            }, {
                headers: authHeaders
            });
            //console.log('Response Data:', response.data);

            // Set the fetched data to the state
            setdetailedDataDefaultReport(response.data);

            // Log before calling fetchperdaypotcycleDefaultReport
            //console.log('Calling fetchperdaypotcycleDefaultReport...');

            await fetchperdaypotcycleDefaultReport();
            await handlePumpNameClickDefaultReport();
            //console.log('Per Day Pot Cycle Data Response:', perDayPotCycleData);

            setLoading(false);
        } catch (error) {
            console.error('Error fetching Pot Analytics data:', error);
            setLoading(false);
        }
    };

    const fetchperdaypotcycleDefaultReport = async () => {
        try {
            const currentDate = moment().format('YYYY-MM-DD');
            const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
            const authHeaders = getAuthHeaders();
            const response = await axios.post(
                `${API_ENDPOINTS.perdaypotcycle}`,
                {
                    selectedDPs,
                    selectedVPs,
                    selectedDateFrom: sevenDaysAgo,
                    selectedDateTo: currentDate,
                    clientId: loggedInUser.clientId,
                    projectID: loggedInUser.Projectid,
                    TimeDiff: loggedInUser.TimeDiff,
                },
                {
                    headers: authHeaders
                }
            );

            // Log the response data
            //console.log('Per Day Pot Cycle Response Data:', response.data);

            // Set the fetched data to the state
            setdetailedData2DefaultReport(response.data);

            // Return the data
            return response.data;

        } catch (error) {
            console.error('Error fetching Per Day Pot Cycle data:', error);
            setLoading(false);
            // Return undefined or handle the error accordingly
            return undefined;
        }
    };

    const handleSearch = async () => {
        setLoading(true);
        handleClearDefaultGenerate();
        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.potAnalyticsData}`, {
                selectedDPs,
                selectedVPs,
                selectedDateFrom: selectedDateFrom ? format(selectedDateFrom, 'yyyy-MM-dd') : null,
                selectedDateTo: selectedDateTo ? format(selectedDateTo, 'yyyy-MM-dd') : null,
                projectID: loggedInUser.Projectid,
                TimeDiff: loggedInUser.TimeDiff,
            }, {
                headers: authHeaders
            });
            //console.log('Response Data:', response.data);

            // Set the fetched data to the state
            setDetailedData(response.data);

            // Check if "Max Tank Level" or "Min Tank Level" is selected
            if (selectedParameters.includes('TotalDurationDay') || selectedParameters.includes('TotalvalveCyclesDay')) {
                await fetchperdaypotcycle();
            } else {
                fetchperdaypotcycle([]);
            }

            setLoading(false);
        } catch (error) {
            console.error('Error fetching Pot Analytics data:', error);
            setLoading(false);
        }
    };

    const fetchperdaypotcycle = async () => {
        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.post(
                `${API_ENDPOINTS.perdaypotcycle}`,
                {
                    selectedDPs,
                    selectedVPs,
                    selectedDateFrom: selectedDateFrom ? format(selectedDateFrom, 'yyyy-MM-dd') : null,
                    selectedDateTo: selectedDateTo ? format(selectedDateTo, 'yyyy-MM-dd') : null,
                    clientId: loggedInUser.clientId,
                    projectID: loggedInUser.Projectid,
                    TimeDiff: loggedInUser.TimeDiff,
                },
                {
                    headers: authHeaders
                }
            );
            //console.log('Response Data:', response.data);

            // Set the fetched data to the state
            setDetailedData2(response.data);

            setLoading(false);
        } catch (error) {
            console.error('Error fetching Pot Analytics data:', error);
            setLoading(false);
            //toast.error('Error fetching data');
        }
    };

    const handleClear = () => {
        setdetailedData2DefaultReport([]);
        setSelectedDateFrom(null);
        setSelectedDateTo(null);
        setDetailedData([]);
        setdetailedDataDefaultReport([]);
        setDetailedData2([]);
        setDetailedData3([]);
    };

    const handleClearDefaultGenerate = () => {
        setdetailedDataDefaultReport([]);
        setdetailedData2DefaultReport([]);
        setDetailedData3([]);
    }

    const handlePumpNameClick = async (potName) => {
        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.potclickdata}`, {
                row: { HEADER: potName },
                selectedDateFrom: selectedDateFrom ? format(selectedDateFrom, 'yyyy-MM-dd') : null,
                selectedDateTo: selectedDateTo ? format(selectedDateTo, 'yyyy-MM-dd') : null,
                projectID: loggedInUser.Projectid,
                TimeDiff: loggedInUser.TimeDiff,
            },
                {
                    headers: authHeaders
                });

            //console.log('Response Data of POTCLICK:', response.data);

            // Update state with the fetched data
            setDetailedData3(response.data);

            // Scroll to detailedData3 table
            if (detailedData3Ref.current) {
                detailedData3Ref.current.scrollIntoView({ behavior: 'smooth' });
            }

        } catch (error) {
            console.error('Error fetching Pot click data:', error);
            //toast.error('Error fetching data');
        }
    };

    const handlePumpNameClickDefaultReport = async (potName) => {
        try {
            // Set loading state before fetching data
            setLoading(true);

            const currentDate = moment().format('YYYY-MM-DD');
            const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
            const authHeaders = getAuthHeaders();

            const response = await axios.post(`${API_ENDPOINTS.DefaultReportPotclickdata}`, {
                selectedDPs,
                selectedVPs,
                selectedDateFrom: sevenDaysAgo,
                selectedDateTo: currentDate,
                projectID: loggedInUser.Projectid,
                TimeDiff: loggedInUser.TimeDiff,
            },
                {
                    headers: authHeaders
                });

            //console.log('Response Data of POTCLICK:', response.data);

            // Update state with the fetched data
            setDetailedData3(response.data);

        } catch (error) {
            console.error('Error fetching Pot click data:', error);
            // Optionally show an error message to users
            // toast.error('Error fetching data');
        } finally {
            // Reset loading state
            setLoading(false);
        }
    };

    const handleDownloadPDF = () => {
        const doc = new jsPDF({
            orientation: 'landscape',
        });

        // Function to generate table content
        const generateTableContent = (tableData, columns, startY) => {
            const rows = tableData.map(row => {
                return columns.map(column => {
                    switch (column.key) {
                        case 'HEADER':
                            return row.HEADER || '0';
                        case 'Total_Duration':
                            return row.Total_Duration || '0Sec';
                        case 'Avg_Duration':
                            return row.Avg_Duration || '0Sec';
                        case 'Max_Duration':
                            return row.Max_Duration || '0Sec';
                        case 'Min_Duration':
                            return row.Min_Duration || '0Sec';
                        case 'Total_Cycles':
                            return row.Total_Cycles || '0'
                        case 'Total_ValveAlarm':
                            return row.Total_ValveAlarm;
                        case 'Total_floatAlarm':
                            return row.Total_floatAlarm || '0';
                        case 'Date':
                            return row.Date || '';
                        case 'POTS':
                            return row.POTS || '0';
                        case 'CYCLEDURATION':
                            return row.CYCLEDURATION || '0Sec';
                        case 'TotalCYCLES':
                            return row.TotalCYCLES || '0';
                        case 'POT':
                            return row.POT || '0';
                        case 'STARTDATE':
                            return formatDate(row.cycleStartTime) || '0';
                        case 'STARTTIME':
                            return formatTime(row.cycleStartTime) || '0';
                        case 'STOPDATE':
                            return formatDate(row.cycleStopTime) || '0';
                        case 'STOPTIME':
                            return formatTime(row.cycleStopTime) || '0';
                        case 'DURATION':
                            return row.DURATION || '0Sec';
                        default:
                            return '';
                    }
                });
            });

            // Add a smaller space after each table
            doc.autoTable({
                head: [columns.map(column => column.label)],
                body: rows,
                startY: startY,
                headStyles: {
                    fillColor: [200, 200, 200],
                    // Grey color (RGB: 169, 169, 169)
                    textColor: [0, 0, 0], // Text color (black)
                    fontSize: 12, // Font size for header text
                    fontStyle: 'bold', // Font style for header text
                },
                theme: 'striped', // Optional: Adds alternating row colors
            });

            return doc.autoTable.previous.finalY + 10; // Adjust this value as needed
        };

        // Add Title
        const title = 'Pot Analytics Report';
        const titleWidth = doc.getStringUnitWidth(title) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const pageWidth = doc.internal.pageSize.width;
        const xTitle = (pageWidth - titleWidth) / 2;
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(18);
        doc.text(title, xTitle, 20);

        // Add Project Name below the title
        const projectName = `Project Name: ${loggedInUser && loggedInUser.project_description}`;
        const projectNameWidth = doc.getStringUnitWidth(projectName) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const xProjectName = (pageWidth - projectNameWidth) / 2;
        doc.text(projectName, xProjectName, 30);

        // Get current date and date 7 days ago
        const currentDate = moment().format('DD-MM-YYYY');
        const sevenDaysAgo = moment().subtract(7, 'days').format('DD-MM-YYYY');
        const fromDateText = `Date between: ${selectedDateFrom ? format(selectedDateFrom, 'dd-MM-yyyy') : sevenDaysAgo} / ${selectedDateTo ? format(selectedDateTo, 'dd-MM-yyyy') : currentDate}`;
        const fromDateWidth = doc.getStringUnitWidth(fromDateText) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const xFromDate = (pageWidth - fromDateWidth) / 2;
        doc.text(fromDateText, xFromDate, 40);

        // Starting y-position for the first table
        let startY = 50;

        // Generate PDF content based on each table
        if (detailedData.length > 0) {
            const columns1 = [
                ...(selectedParameters.some(param =>
                    ['TotalDuration', 'TotalvalveCycles', 'Totalvalvealarm', 'TotalFloatalarm',
                        'AverageDuration', 'MaxDuration', 'MinDuration'].includes(param)) ? [
                    { key: 'HEADER', label: 'Pot name' },
                ] : []),
                ...(selectedParameters.includes('TotalvalveCycles') ? [
                    { key: 'Total_Cycles', label: 'Total valve runs' },
                ] : []),
                ...(selectedParameters.includes('Totalvalvealarm') ? [
                    { key: 'Total_ValveAlarm', label: 'Total valve alarms' },
                ] : []),
                ...(selectedParameters.includes('TotalFloatalarm') ? [
                    { key: 'Total_floatAlarm', label: 'Total float alarms' },
                ] : []),
                ...(selectedParameters.includes('TotalDuration') ? [
                    { key: 'Total_Duration', label: 'Total run time' },
                ] : []),
                ...(selectedParameters.includes('AverageDuration') ? [
                    { key: 'Avg_Duration', label: 'Average run time' },
                ] : []),
                ...(selectedParameters.includes('MaxDuration') ? [
                    { key: 'Max_Duration', label: 'Max run time' },
                ] : []),
                ...(selectedParameters.includes('MinDuration') ? [
                    { key: 'Min_Duration', label: 'Min run time' },
                ] : []),
            ];
            startY = generateTableContent(detailedData, columns1, startY);
        }

        // Generate PDF content based on each table
        if (detailedDataDefaultReport.length > 0) {
            const columns1 = [
                { key: 'HEADER', label: 'Pot name' },
                { key: 'Total_Cycles', label: 'Total valve runs' },
                { key: 'Total_ValveAlarm', label: 'Total valve alarms' },
                { key: 'Total_floatAlarm', label: 'Total float alarms' },
                { key: 'Total_Duration', label: 'Total run time' },
                { key: 'Avg_Duration', label: 'Average run time' },
                { key: 'Max_Duration', label: 'Max run time' },
                { key: 'Min_Duration', label: 'Min run time' }
            ];
            startY = generateTableContent(detailedDataDefaultReport, columns1, startY);
        }

        if (detailedData2.length > 0) {
            const columns2 = [
                ...(selectedParameters.some(param =>
                    ['TotalCyclesPerDay', 'TotalDurationDay'].includes(param)) ? [
                    { key: 'POTS', label: 'Pot' },
                ] : []),
                ...(selectedParameters.some(param =>
                    ['TotalCyclesPerDay', 'TotalDurationDay'].includes(param)) ? [
                    { key: 'Date', label: 'Date' },
                ] : []),
                ...(selectedParameters.includes('TotalDurationDay') ? [
                    { key: 'CYCLEDURATION', label: 'Total run time/day' },
                ] : []),
                ...(selectedParameters.includes('TotalvalveCyclesDay') ? [
                    { key: 'TotalCYCLES', label: 'Total runs/day' }
                ] : []),
            ];
            startY = generateTableContent(detailedData2, columns2, startY);
        }

        if (detailedData2DefaultReport.length > 0) {
            const columns2 = [
                { key: 'POTS', label: 'Pot' },
                { key: 'Date', label: 'Date' },
                { key: 'CYCLEDURATION', label: 'Total run time/day' },
                { key: 'TotalCYCLES', label: 'Total runs/day' }
            ];
            startY = generateTableContent(detailedData2DefaultReport, columns2, startY);
        }

        if (detailedData3.length > 0) {
            const columns3 = [
                { key: 'POT', label: 'POT' },
                { key: 'STARTDATE', label: 'Start date' },
                { key: 'STARTTIME', label: 'Start time' },
                { key: 'STOPDATE', label: 'Stop date' },
                { key: 'STOPTIME', label: 'Stop time' },
                { key: 'DURATION', label: 'Run time' }
            ];
            generateTableContent(detailedData3, columns3, startY);
        }

        // Save the PDF
        doc.save('pot_analytics_report.pdf');
    };


    const handleDownloadExcel = () => {
        const XLSX = require('xlsx');
        const wb = XLSX.utils.book_new();
        const wsData = [];
        const currentDate = moment().format('DD-MM-YYYY');
        const sevenDaysAgo = moment().subtract(7, 'days').format('DD-MM-YYYY');
        // Header lines
        const headerLines = [
            ['Pot Analytics Report'],
            [`Project Name: ${loggedInUser && loggedInUser.project_description}`],
            [`Date between: ${selectedDateFrom ? format(selectedDateFrom, 'dd-MM-yyyy') : sevenDaysAgo} / ${selectedDateTo ? format(selectedDateTo, 'dd-MM-yyyy') : currentDate}`]
        ];
        wsData.push(...headerLines);

        // Function to generate Excel content for a specific data set
        const generateExcelContent = (data, columns) => {
            const header = columns.map(column => column.label);
            const rows = data.map(row => columns.map(column => {
                switch (column.key) {
                    case 'HEADER':
                        return row.HEADER || '0';
                    case 'Total_Duration':
                        return row.Total_Duration || '0Sec';
                    case 'Avg_Duration':
                        return row.Avg_Duration || '0Sec';
                    case 'Max_Duration':
                        return row.Max_Duration || '0Sec';
                    case 'Min_Duration':
                        return row.Min_Duration || '0Sec';
                    case 'Total_Cycles':
                        return row.Total_Cycles || '0'
                    case 'Total_ValveAlarm':
                        return row.Total_ValveAlarm;
                    case 'Total_floatAlarm':
                        return row.Total_floatAlarm || '0';
                    case 'Date':
                        return row.Date || '';
                    case 'POTS':
                        return row.POTS || '0';
                    case 'CYCLEDURATION':
                        return row.CYCLEDURATION || '0Sec';
                    case 'TotalCYCLES':
                        return row.TotalCYCLES || '0';
                    case 'POT':
                        return row.POT || '0';
                    case 'STARTDATE':
                        return formatDate(row.cycleStartTime) || '0';
                    case 'STARTTIME':
                        return formatTime(row.cycleStartTime) || '0';
                    case 'STOPDATE':
                        return formatDate(row.cycleStopTime) || '0';
                    case 'STOPTIME':
                        return formatTime(row.cycleStopTime) || '0';
                    case 'DURATION':
                        return row.DURATION || '0Sec';

                    default:
                        return '';
                }
            }));

            // Add empty row for spacing
            rows.push(Array(header.length).fill(''));

            return [header, ...rows];
        };

        if (detailedData.length > 0) {
            const columns1 = [
                ...(selectedParameters.some(param =>
                    ['TotalDuration', 'TotalvalveCycles', 'Totalvalvealarm', 'TotalFloatalarm',
                        'AverageDuration', 'MaxDuration', 'MinDuration'].includes(param)) ? [
                    { key: 'HEADER', label: 'Pot name' },
                ] : []),
                ...(selectedParameters.includes('TotalvalveCycles') ? [
                    { key: 'Total_Cycles', label: 'Total valve runs' },
                ] : []),
                ...(selectedParameters.includes('Totalvalvealarm') ? [
                    { key: 'Total_ValveAlarm', label: 'Total valve alarms' },
                ] : []),
                ...(selectedParameters.includes('TotalFloatalarm') ? [
                    { key: 'Total_floatAlarm', label: 'Total float alarms' },
                ] : []),
                ...(selectedParameters.includes('TotalDuration') ? [
                    { key: 'Total_Duration', label: 'Total run time' },
                ] : []),
                ...(selectedParameters.includes('AverageDuration') ? [
                    { key: 'Avg_Duration', label: 'Average run time' },
                ] : []),
                ...(selectedParameters.includes('MaxDuration') ? [
                    { key: 'Max_Duration', label: 'Max run time' },
                ] : []),
                ...(selectedParameters.includes('MinDuration') ? [
                    { key: 'Min_Duration', label: 'Min run time' },
                ] : []),
            ];
            wsData.push(...generateExcelContent(detailedData, columns1));
        }

        if (detailedDataDefaultReport.length > 0) {
            const columns1 = [
                { key: 'HEADER', label: 'Pot name' },
                { key: 'Total_Cycles', label: 'Total valve runs' },
                { key: 'Total_ValveAlarm', label: 'Total valve alarms' },
                { key: 'Total_floatAlarm', label: 'Total float alarms' },
                { key: 'Total_Duration', label: 'Total run time' },
                { key: 'Avg_Duration', label: 'Average run time' },
                { key: 'Max_Duration', label: 'Max run time' },
                { key: 'Min_Duration', label: 'Min run time' },
            ];
            wsData.push(...generateExcelContent(detailedDataDefaultReport, columns1));
        }

        if (detailedData2.length > 0) {
            const columns2 = [
                { key: 'POTS', label: 'Pot name' },
                { key: 'Date', label: 'Date' },
                { key: 'CYCLEDURATION', label: 'Total run time/day' },
                { key: 'TotalCYCLES', label: 'Total cycles/day' }
            ];
            wsData.push(...generateExcelContent(detailedData2, columns2));
        }

        if (detailedData2DefaultReport.length > 0) {
            const columns2 = [
                ...(selectedParameters.some(param =>
                    ['TotalCyclesPerDay', 'TotalDurationDay'].includes(param)) ? [
                    { key: 'POTS', label: 'Pot' },
                ] : []),
                ...(selectedParameters.some(param =>
                    ['TotalCyclesPerDay', 'TotalDurationDay'].includes(param)) ? [
                    { key: 'Date', label: 'Date' },
                ] : []),
                ...(selectedParameters.includes('TotalDurationDay') ? [
                    { key: 'CYCLEDURATION', label: 'Total run time/day' },
                ] : []),
                ...(selectedParameters.includes('TotalvalveCyclesDay') ? [
                    { key: 'TotalCYCLES', label: 'Total runs/day' }
                ] : []),
            ];
            wsData.push(...generateExcelContent(detailedData2DefaultReport, columns2));
        }

        if (detailedData3.length > 0) {
            const columns3 = [
                { key: 'POT', label: 'Pot' },
                { key: 'STARTDATE', label: 'Start date' },
                { key: 'STARTTIME', label: 'Start time' },
                { key: 'STOPDATE', label: 'Stop date' },
                { key: 'STOPTIME', label: 'Stop time' },
                { key: 'DURATION', label: 'Run time' }
            ];
            wsData.push(...generateExcelContent(detailedData3, columns3));
        }

        // Create a single worksheet from all data
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Set column widths and style for centered alignment
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const colWidth = wsData.reduce((acc, row) => Math.max(acc, `${row[C]}`.length), 0) + 3;
            ws['!cols'] = ws['!cols'] || [];
            ws['!cols'][C] = { wch: colWidth, s: { alignment: { horizontal: 'center' } } };
        }

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'PotAna');

        // Save the Excel file
        XLSX.writeFile(wb, 'pot_analytics_report.xlsx');
    };

    const handleLevels = (event) => {
        const { value } = event.target;
        setSelectedLevels(value);
    };


    const [selectedDateFrom, setSelectedDateFrom] = useState(null);

    const handleDateFrom = (date) => {
        setSelectedDateFrom(date);
    };

    const handleDateTo = (date) => {
        setSelectedDateTo(date);
    };

    const fetchDataselectpotdata = async () => {
        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.get(`${API_ENDPOINTS.selectpotdata}?Projectid=${loggedInUser.Projectid}`, {
                headers: authHeaders
            });
            const potData = response.data.map(item => item.pot);
            //console.log('Response Data fetchDataselectpotdata:', response.data);
            setPotOptions(potData);
            setPotOptionsDefaultReport(potData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const formatDate = (dateString) => {
        // Parse the date string in the format DD-MM-YYYY HH:MM:SS
        const [datePart] = dateString.split(' '); // Extract the date part
        const [day, month, year] = datePart.split('-'); // Split into day, month, year
        return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
    };

    const formatTime = (dateString) => {
        if (!dateString) {
            return ''; // Return an empty string if the dateString is falsy
        }

        // Split the dateString into date and time parts
        const parts = dateString.split(' ');

        // Check if the time part exists
        if (parts.length < 2) {
            return ''; // Return an empty string if there's no time part
        }

        const timePart = parts[1]; // Get the time part

        // If the time part exists, return it formatted as HH:MM:SS
        return timePart.split(':').slice(0, 3).join(':');
    };

    useEffect(() => {
        fetchDataselectpotdata();

    }, [loggedInUser]);

    useEffect(() => {
        if (potOptions.length > 0) {
            setSelectedDPs([potOptions[0]]);
            setSelectedVPs([potOptions[potOptions.length - 1]]);
            setSelectedParameters(parameterOptions.map((param) => param.value));
        }
    }, [potOptions]);

    const handleDP = (event) => {
        setSelectedDPs([event.target.value]);
    };

    const handleVP = (event) => {
        setSelectedVPs([event.target.value]);
    };

    const handleParameters = (event) => {
        const value = event.target.value;

        if (value.includes('SelectAll')) {
            // Set all parameters as selected
            setSelectedParameters(parameterOptions.map((param) => param.value));
        } else {
            // Regular selection of individual parameters
            setSelectedParameters(value);
        }
    };

    const toggleVisibility = (event) => {
        setIsVisible(event.target.checked);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div style={{ backgroundColor: '#EBEFF3' }}>
                <Sidebar loggedInUser={loggedInUser} />
                <Header
                    logoUrl={logoUrl}
                    loggedInUser={loggedInUser}
                    onLogout={onLogout}
                    username={username}
                    userRole={userRole}
                />

                <ContentContainer>
                    <MainContent>
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} lg={20}>
                                <CenteredCard>
                                    <CardContent>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box>
                                                <HeaderTitle>Pot Analytics</HeaderTitle>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on small screens
                                                        alignItems: 'flex-start', // Align items to the start for vertical stacking
                                                        gap: { xs: 1, sm: 1 }, // Gap for spacing, smaller on mobile
                                                        width: '100%', // Full width for better usability on mobile
                                                    }}
                                                >
                                                    {/* Select From */}
                                                    <Select
                                                        value={selectedDPs}
                                                        onChange={handleDP}
                                                        displayEmpty
                                                        sx={{
                                                            width: '100%', // Full width for better usability
                                                            fontSize: { xs: 'small', sm: 'small' }, // Smaller font size on mobile
                                                            color: 'dodgerblue',
                                                            padding: 0,
                                                            border: 'none',
                                                            minWidth: '80px',
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                border: 'none',
                                                            },
                                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                borderBottom: '1px dashed #FFA703',
                                                            },
                                                        }}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 200,
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em>Select From</em>
                                                        </MenuItem>
                                                        {potOptionsDefaultReport.map((option) => (
                                                            <MenuItem key={option} value={option}>
                                                                {option}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>

                                                    {/* Select To */}
                                                    <Select
                                                        value={selectedVPs}
                                                        onChange={handleVP}
                                                        displayEmpty
                                                        sx={{
                                                            width: '100%', // Full width for better usability
                                                            fontSize: { xs: 'small', sm: 'small' }, // Smaller font size on mobile
                                                            color: 'dodgerblue',
                                                            padding: 0,
                                                            border: 'none',
                                                            minWidth: '80px',
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                border: 'none',
                                                            },
                                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                borderBottom: '1px dashed #FFA703',
                                                            },
                                                        }}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 200,
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em>Select To</em>
                                                        </MenuItem>
                                                        {potOptionsDefaultReport.map((option) => (
                                                            <MenuItem key={option} value={option}>
                                                                {option}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>

                                                    {/* Generate Default Report */}
                                                    <Typography
                                                        variant="body2"
                                                        component="a"
                                                        onClick={handleDefaultGenerate}
                                                        href="#"
                                                        sx={{
                                                            color: 'dodgerblue',
                                                            textDecoration: 'none',
                                                            mt: { sm: 0 }, // Margin top for mobile
                                                            ml: 2,
                                                            width: '100%', // Full width for button on mobile
                                                            '&:hover': {
                                                                textDecoration: 'underline',
                                                            },
                                                        }}
                                                    >
                                                        Generate Default Report
                                                        <Typography
                                                            component="span"
                                                            sx={{
                                                                color: 'dodgerblue', // Warm orange for contrast
                                                                fontSize: '0.85rem',
                                                                fontWeight: '500', // Semi-bold for a refined look
                                                                ml: 0.5
                                                            }}
                                                        >
                                                            (Last 7 days)
                                                        </Typography>
                                                    </Typography>
                                                </Box>


                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={isVisible}
                                                                onChange={toggleVisibility}
                                                                color="primary"
                                                            />
                                                        }
                                                        label={isVisible ? "" : ""}
                                                    />
                                                </FormGroup>
                                                <Box sx={{ ml: 1 }}>
                                                    <RefreshIcon
                                                        title="Refresh"
                                                        src={refreshIcon}
                                                        label="Click to refresh"
                                                        alt="Refresh"
                                                        onClick={() => window.location.reload()}
                                                        sx={{ cursor: 'pointer' }} // Add pointer cursor for better UX
                                                    />
                                                </Box>
                                            </Box>
                                        </Box>
                                        {isVisible && (
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6} md={1.5}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <InputLabel id="dp-select-label">Pot From</InputLabel>
                                                            <Select
                                                                value={selectedDPs}
                                                                onChange={handleDP}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                        {selected.length > 0 ? (
                                                                            selected.map((value) => (
                                                                                <Chip
                                                                                    key={value}
                                                                                    label={value}
                                                                                    size="small"
                                                                                    style={{ fontSize: '0.75rem', height: '20px' }}
                                                                                />
                                                                            ))
                                                                        ) : (
                                                                            <em style={{ color: '#808080' }}>Select Pot</em>
                                                                        )}
                                                                    </Box>
                                                                )}
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        style: {
                                                                            maxHeight: 300,
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                {potOptions.map((description, index) => (
                                                                    <MenuItem key={description} value={description} >
                                                                        {description}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={1.5}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <InputLabel id="vp-select-label">Pot To</InputLabel>
                                                            <Select
                                                                value={selectedVPs}
                                                                onChange={handleVP}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                        {selected.length > 0 ? (
                                                                            selected.map((value) => (
                                                                                <Chip
                                                                                    key={value}
                                                                                    label={value}
                                                                                    size="small"
                                                                                    style={{ fontSize: '0.75rem', height: '20px' }}
                                                                                />
                                                                            ))
                                                                        ) : (
                                                                            <em style={{ color: '#808080' }}>Select Pot</em>
                                                                        )}
                                                                    </Box>
                                                                )}
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        style: {
                                                                            maxHeight: 300,
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                {potOptions.map((description, index) => (
                                                                    <MenuItem key={description} value={description}>
                                                                        {description}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>

                                                <Grid item xs={12} sm={6} md={3.5}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <InputLabel id="parameter-select-label">Select Parameters</InputLabel>
                                                            <Select
                                                                labelId="parameter-select-label"
                                                                multiple
                                                                value={selectedParameters}
                                                                onChange={handleParameters}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                        {selected.map((value) => (
                                                                            <Chip
                                                                                key={value}
                                                                                label={parameterOptions.find(param => param.value === value)?.label || value}
                                                                                size="small"
                                                                                style={{ fontSize: '0.75rem', height: '20px' }} // Adjust the font size and height to make it smaller
                                                                            />
                                                                        ))}
                                                                    </Box>
                                                                )}
                                                            >
                                                                <MenuItem value="SelectAll">Select All</MenuItem>
                                                                {parameterOptions.map((option) => (
                                                                    <MenuItem key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>

                                                <Grid item xs={12} sm={6} md={2}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <DatePicker
                                                                label="Select From"
                                                                value={selectedDateFrom}
                                                                onChange={handleDateFrom}
                                                                minDate={thirtyDaysAgo}
                                                                maxDate={today}
                                                                renderInput={(params) => <CustomTextField {...params} />}
                                                                inputFormat="dd/MM/yyyy"
                                                                sx={{
                                                                    width: '100%',
                                                                    '& .MuiInputLabel-root': {
                                                                        fontSize: '0.75rem',
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontSize: '0.8rem',
                                                                    },
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>

                                                <Grid item xs={12} sm={6} md={2}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <DatePicker
                                                                label="Select To"
                                                                value={selectedDateTo}
                                                                onChange={handleDateTo}
                                                                minDate={selectedDateFrom || thirtyDaysAgo}
                                                                maxDate={today}
                                                                renderInput={(params) => <CustomTextField {...params} />}
                                                                inputFormat="dd/MM/yyyy"
                                                                sx={{
                                                                    width: '100%',
                                                                    '& .MuiInputLabel-root': {
                                                                        fontSize: '0.75rem',
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontSize: '0.8rem',
                                                                    },
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>
                                            </Grid>
                                        )}

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', sm: 'row' }, // Stack elements vertically on small screens
                                                justifyContent: 'flex-end',
                                                alignItems: 'center',
                                                gap: { xs: 1, sm: 0 }, // Add some gap for stacked layout
                                            }}
                                        >
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={handleSearch}
                                                disabled={loading}
                                                sx={{
                                                    marginRight: { xs: 0, sm: '10px' }, // Remove margin on small screens
                                                    borderRadius: '5px',
                                                    padding: '2px 6px',
                                                    fontSize: { xs: '0.65rem', sm: '0.75rem' }, // Smaller font size on mobile
                                                    width: { xs: '100%', sm: 'auto' }, // Full width on mobile
                                                    '& .MuiButton-startIcon': {
                                                        margin: 0,
                                                    },
                                                    '&:hover': {
                                                        backgroundColor: '#D9FEE5',
                                                    },
                                                }}
                                            >
                                                {loading ? <CircularProgress size={20} /> : 'Search'}
                                            </Button>

                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={handleClear}
                                                sx={{
                                                    marginRight: { xs: 0, sm: '50px' }, // Remove margin on small screens
                                                    borderRadius: '5px',
                                                    padding: '2px 6px',
                                                    fontSize: { xs: '0.65rem', sm: '0.75rem' }, // Smaller font size on mobile
                                                    width: { xs: '100%', sm: 'auto' }, // Full width on mobile
                                                    '& .MuiButton-startIcon': {
                                                        margin: 0,
                                                    },
                                                    '&:hover': {
                                                        backgroundColor: '#FFCCCB',
                                                    },
                                                }}
                                            >
                                                Clear
                                            </Button>

                                            <Box sx={{ display: 'flex', flexDirection: { xs: 'row', sm: 'row' }, gap: 1 }}>
                                                <a href="#" onClick={handleDownloadPDF} style={{ marginRight: '5px' }}>
                                                    <img src={pdfIcon} alt="PDF" style={{ marginRight: '5px', height: '50px' }} /> {/* Adjusted size for mobile */}
                                                </a>

                                                <a href="#" onClick={handleDownloadExcel} style={{ marginRight: '10px' }}>
                                                    <img src={excelIcon} alt="Excel" style={{ marginRight: '5px', height: '50px' }} /> {/* Adjusted size for mobile */}
                                                </a>
                                            </Box>
                                        </Box>

                                    </CardContent>
                                </CenteredCard>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <CardContent>
                                {/* Table One */}
                                <Box sx={{ marginBottom: '30px' }}>
                                    {detailedDataDefaultReport.length > 0 ? (
                                        <StyledTableContainer>
                                            <Box display="flex" justifyContent="flex-end" mb={2}>
                                                <Stack spacing={2}>
                                                    <Pagination
                                                        count={Math.ceil(detailedDataDefaultReport.length / rowsPerPageOne)}
                                                        page={currentPageOne}
                                                        onChange={handlePageChangeOne}
                                                        variant="outlined"
                                                        color="primary"
                                                    />
                                                </Stack>
                                            </Box>
                                            <Table>
                                                <StyledTableHead>
                                                    <TableRow>
                                                        <StyledTableColumn>Pot name</StyledTableColumn>
                                                        <StyledTableColumn>Total valve runs</StyledTableColumn>
                                                        <StyledTableColumn>Total valve alarms</StyledTableColumn>
                                                        <StyledTableColumn>Total float alarms</StyledTableColumn>
                                                        <StyledTableColumn>Total run time</StyledTableColumn>
                                                        <StyledTableColumn>Average run time</StyledTableColumn>
                                                        <StyledTableColumn>Max run time</StyledTableColumn>
                                                        <StyledTableColumn>Min run time</StyledTableColumn>
                                                    </TableRow>
                                                </StyledTableHead>
                                                <TableBody>
                                                    {paginatedDataOne.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <StyledTableCell>{row.HEADER || '0'}</StyledTableCell>
                                                            <StyledTableCell>{row.Total_Cycles || '0'}</StyledTableCell>
                                                            <StyledTableCell>{row.Total_ValveAlarm || '0'}</StyledTableCell>
                                                            <StyledTableCell>{row.Total_floatAlarm || '0'}</StyledTableCell>
                                                            <StyledTableCell>{row.Total_Duration || '0Sec'}</StyledTableCell>
                                                            <StyledTableCell>{row.Avg_Duration || '0Sec'}</StyledTableCell>
                                                            <StyledTableCell>{row.Max_Duration || '0Sec'}</StyledTableCell>
                                                            <StyledTableCell>{row.Min_Duration || '0Sec'}</StyledTableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </StyledTableContainer>
                                    ) : (
                                        <Typography variant="body2" color="textSecondary" component="p">

                                        </Typography>
                                    )}
                                </Box>

                                {/* Table Two */}
                                <Box sx={{ marginBottom: '30px' }}>
                                    {detailedData2DefaultReport.length > 0 ? (
                                        <StyledTableContainer>
                                            <Box display="flex" justifyContent="flex-end" mb={2}>
                                                <Stack spacing={2}>
                                                    <Pagination
                                                        count={Math.ceil(detailedData2DefaultReport.length / rowsPerPageTwo)}
                                                        page={currentPageTwo}
                                                        onChange={handlePageChangeTwo}
                                                        variant="outlined"
                                                        color="primary"
                                                    />
                                                </Stack>
                                            </Box>
                                            <Table>
                                                <StyledTableHead>
                                                    <TableRow>
                                                        <StyledTableColumn>Pot name</StyledTableColumn>
                                                        <StyledTableColumn>Date</StyledTableColumn>
                                                        <StyledTableColumn>Total run time/day</StyledTableColumn>
                                                        <StyledTableColumn>Total runs/day</StyledTableColumn>
                                                    </TableRow>
                                                </StyledTableHead>
                                                <TableBody>
                                                    {paginatedDataTwo.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <StyledTableCell>
                                                                {row.POTS}
                                                            </StyledTableCell>
                                                            <StyledTableCell>{row.Date}</StyledTableCell>
                                                            <StyledTableCell>{row.CYCLEDURATION || '0Sec'}</StyledTableCell>
                                                            <StyledTableCell>{row.TotalCYCLES || '0'}</StyledTableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </StyledTableContainer>
                                    ) : (
                                        <Typography variant="body2" color="textSecondary" component="p">

                                        </Typography>
                                    )}
                                </Box>

                                {/* Table Three */}
                                <Box>
                                    {detailedData.length > 0 ? (
                                        <StyledTableContainer>
                                            <Box display="flex" justifyContent="flex-end" mb={2}>
                                                <Stack spacing={2}>
                                                    <Pagination
                                                        count={Math.ceil(detailedData.length / rowsPerPageThree)}
                                                        page={currentPageThree}
                                                        onChange={handlePageChangeThree}
                                                        variant="outlined"
                                                        color="primary"
                                                    />
                                                </Stack>
                                            </Box>
                                            <Table>
                                                <StyledTableHead>
                                                    <TableRow>
                                                        {selectedParameters.some(param =>
                                                            ['TotalDuration', 'TotalvalveCycles', 'Totalvalvealarm', 'TotalFloatalarm',
                                                                'AverageDuration', 'MaxDuration', 'MinDuration'].includes(param)) &&
                                                            <StyledTableColumn>Pot name</StyledTableColumn>
                                                        }
                                                        {selectedParameters.includes('TotalvalveCycles') && <StyledTableColumn>Total valve runs</StyledTableColumn>}
                                                        {selectedParameters.includes('Totalvalvealarm') && <StyledTableColumn>Total valve alarms</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalFloatalarm') && <StyledTableColumn>Total float alarms</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalDuration') && <StyledTableColumn>Total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('AverageDuration') && <StyledTableColumn>Average run time</StyledTableColumn>}
                                                        {selectedParameters.includes('MaxDuration') && <StyledTableColumn>Max run time</StyledTableColumn>}
                                                        {selectedParameters.includes('MinDuration') && <StyledTableColumn>Min run time</StyledTableColumn>}
                                                    </TableRow>
                                                </StyledTableHead>
                                                <TableBody>
                                                    {paginatedDataThree.map((row, index) => (
                                                        <TableRow key={index}>
                                                            {selectedParameters.some(param =>
                                                                ['TotalDuration', 'TotalvalveCycles', 'Totalvalvealarm', 'TotalFloatalarm',
                                                                    'AverageDuration', 'MaxDuration', 'MinDuration'].includes(param)) && <StyledTableCell>
                                                                    <Link
                                                                        to="#"
                                                                        onClick={() => handlePumpNameClick(row.HEADER)}
                                                                        style={{
                                                                            textDecoration: 'none',
                                                                            color: 'dodgerblue',
                                                                            fontWeight: 'bold',
                                                                            backgroundColor: '#e0f7fa', // Light blue background
                                                                            padding: '4px 8px', // Increased padding for better touch target
                                                                            borderRadius: '8px', // More rounded corners
                                                                            transition: 'background-color 0.3s, color 0.3s', // Smooth transition effects
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.target.style.backgroundColor = '#b2ebf2'; // Slightly darker blue on hover
                                                                            e.target.style.color = '#007bb2'; // Darker blue text on hover
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.target.style.backgroundColor = '#e0f7fa'; // Revert to original background
                                                                            e.target.style.color = 'dodgerblue'; // Revert to original text color
                                                                        }}
                                                                    >
                                                                        {row.HEADER}
                                                                    </Link>
                                                                </StyledTableCell>}
                                                            {selectedParameters.includes('TotalvalveCycles') && <StyledTableCell>{row.Total_Cycles || '0'}</StyledTableCell>}
                                                            {selectedParameters.includes('Totalvalvealarm') && <StyledTableCell>{row.Total_ValveAlarm || '0'}</StyledTableCell>}
                                                            {selectedParameters.includes('TotalFloatalarm') && <StyledTableCell>{row.Total_floatAlarm || '0'}</StyledTableCell>}
                                                            {selectedParameters.includes('TotalDuration') && <StyledTableCell>{row.Total_Duration || '0Sec'}</StyledTableCell>}
                                                            {selectedParameters.includes('AverageDuration') && <StyledTableCell>{row.Avg_Duration || '0Sec'}</StyledTableCell>}
                                                            {selectedParameters.includes('MaxDuration') && <StyledTableCell>{row.Max_Duration || '0Sec'}</StyledTableCell>}
                                                            {selectedParameters.includes('MinDuration') && <StyledTableCell>{row.Min_Duration || '0Sec'}</StyledTableCell>}
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </StyledTableContainer>
                                    ) : (
                                        <Typography variant="body2" color="textSecondary" component="p">

                                        </Typography>
                                    )}
                                </Box>

                                <Box sx={{ marginBottom: '30px' }}>
                                    {selectedParameters.some(param =>
                                        ['TotalDurationDay', 'TotalvalveCyclesDay'].includes(param)
                                    ) && detailedData2.length > 0 ? (
                                        <StyledTableContainer>
                                            <Box display="flex" justifyContent="flex-end" mb={2}>
                                                <Stack spacing={2}>
                                                    <Pagination
                                                        count={Math.ceil(detailedData2.length / rowsPerPageFour)}
                                                        page={currentPageFour}
                                                        onChange={handlePageChangeFour}
                                                        variant="outlined"
                                                        color="primary"
                                                    />
                                                </Stack>
                                            </Box>
                                            <Table>
                                                <StyledTableHead>
                                                    <TableRow>
                                                        {selectedParameters.some(param =>
                                                            ['TotalDurationDay', 'TotalvalveCyclesDay'].includes(param)) &&
                                                            <StyledTableColumn>Pot name</StyledTableColumn>
                                                        }
                                                        {selectedParameters.some(param =>
                                                            ['TotalDurationDay', 'TotalvalveCyclesDay'].includes(param)) &&
                                                            <StyledTableColumn>Date</StyledTableColumn>
                                                        }
                                                        {selectedParameters.includes('TotalDurationDay') && <StyledTableColumn>Total run time/day</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalvalveCyclesDay') && <StyledTableColumn>Total runs/day</StyledTableColumn>}
                                                    </TableRow>
                                                </StyledTableHead>
                                                <TableBody>
                                                    {paginatedDataFour.map((row, index) => (
                                                        <TableRow key={index}>
                                                            {selectedParameters.some(param =>
                                                                ['TotalDurationDay', 'TotalvalveCyclesDay'].includes(param)) &&
                                                                <StyledTableCell>
                                                                    {row.POTS}
                                                                </StyledTableCell>
                                                            }
                                                            {selectedParameters.some(param =>
                                                                ['TotalDurationDay', 'TotalvalveCyclesDay'].includes(param)) &&
                                                                <StyledTableCell>{row.Date}</StyledTableCell>
                                                            }
                                                            {selectedParameters.includes('TotalDurationDay') && <StyledTableCell>{row.CYCLEDURATION || '0Sec'}</StyledTableCell>}
                                                            {selectedParameters.includes('TotalvalveCyclesDay') && <StyledTableCell>{row.TotalCYCLES || '0'}</StyledTableCell>}
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </StyledTableContainer>
                                    ) : (
                                        <Typography variant="body2" color="textSecondary" component="p">
                                        </Typography>
                                    )}
                                </Box>

                                <Box sx={{ marginBottom: '30px' }}>
                                    {detailedData3.length > 0 ? (
                                        <StyledTableContainer>
                                            <Box display="flex" justifyContent="flex-end" mb={2}>
                                                <Stack spacing={2}>
                                                    <Pagination
                                                        count={Math.ceil(detailedData3.length / rowsPerPageFive)}
                                                        page={currentPageFive}
                                                        onChange={handlePageChangeFive}
                                                        variant="outlined"
                                                        color="primary"
                                                    />
                                                </Stack>
                                            </Box>
                                            <Table>
                                                <StyledTableHead>
                                                    <TableRow>
                                                        <StyledTableColumn>Pot</StyledTableColumn>
                                                        <StyledTableColumn>Start date</StyledTableColumn>
                                                        <StyledTableColumn>Start time</StyledTableColumn>
                                                        <StyledTableColumn>Stop date</StyledTableColumn>
                                                        <StyledTableColumn>Stop time</StyledTableColumn>
                                                        <StyledTableColumn>Run time</StyledTableColumn>
                                                    </TableRow>
                                                </StyledTableHead>
                                                <TableBody>
                                                    {paginatedDataFive.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <StyledTableCell>{row.POT}</StyledTableCell>
                                                            <StyledTableCell>{formatDate(row.cycleStartTime) || 'NA'}</StyledTableCell>
                                                            <StyledTableCell>{formatTime(row.cycleStartTime) || 'NA'}</StyledTableCell>
                                                            <StyledTableCell>{formatDate(row.cycleStopTime) || 'NA'}</StyledTableCell>
                                                            <StyledTableCell>{formatTime(row.cycleStopTime) || 'NA'}</StyledTableCell>
                                                            <StyledTableCell>{row.DURATION || '0Sec'}</StyledTableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </StyledTableContainer>
                                    ) : (
                                        <Typography variant="body2" color="textSecondary" component="p">

                                        </Typography>
                                    )}
                                </Box>
                            </CardContent>
                        </Grid>

                    </MainContent>
                </ContentContainer>
                <Footer />
                <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
                <ToastContainer />
            </div>
        </LocalizationProvider >
    );
};

export default PotAnalytics;